export default __webpack_public_path__ + "5d31d09559c44fff681cb1eaa6656d52.svg";